// extracted by mini-css-extract-plugin
export default {"faqs_page":"faqs_faqs_page__odEEs","faqs_wrapper":"faqs_faqs_wrapper__uUGcO","ant-typography":"faqs_ant-typography__72xhR","faqs_content":"faqs_faqs_content__pHcWI"};